import { Injectable } from '@angular/core';
import {getToastBannerProps, getToastBannerState} from '../../../../core/state/selectors/toastBanner.selector';
import {Store} from '@ngrx/store';

@Injectable({
  providedIn: 'root',
})
export class ToastBannerService {
  constructor(private store: Store) {
    this.store.select(getToastBannerProps).subscribe(
        data => {
          if (data['type']) {
            this.setDeploymentBanner(data);
            setTimeout(() => {
              this.clearBannerParams();
            }, 5000);
          }
        }
    );
  }

  bannerOpen = false;

  private defaultBannerParams = {
    lineColor: null,
    icon: null,
    title: null,
    desc: null,
    bigIcon: false,
    link: null,
    closeIcon: true,
  };

  private bannerParams = this.defaultBannerParams;

  clearBannerParams() {
    this.bannerParams = this.defaultBannerParams;
    this.bannerOpen = false;
  }

  getBannerParams() {
    return this.bannerParams;
  }

  setBannerParams(params) {
    this.bannerParams = {
      lineColor: params.lineColor ? params.lineColor : null,
      icon: params.icon ? params.icon : null,
      title: params.title ? params.title : null,
      desc: params.desc || null,
      bigIcon: !!params.bigIcon,
      link: params.link || null,
      closeIcon: !!params.closeIcon,
    };

    this.bannerOpen = true;
  }

  setDeploymentBanner(data: {}) {
    switch (data['type']) {
      case 'success':
        this.setBannerParams({
          lineColor: '#8cc63f',
          icon: 'redesign/Check_Mark_Filled.svg',
          title: data['title'],
          desc: data['body'],
          bigIcon: false,
          closeIcon: true
        });
        break;
      case 'warning':
        this.setBannerParams({
          lineColor: '#f8bd32',
          icon: 'redesign/ExclamationMark.svg',
          title: data['title'],
          desc: data['body'],
          bigIcon: false,
          closeIcon: true
        });
        break;
      case 'error':
        this.setBannerParams({
          lineColor: '#C23313',
          icon: 'redesign/ExclamationMark_Red.svg',
          title: data['title'],
          desc: data['body'],
          bigIcon: false,
          closeIcon: true
        });
        break;
    }
  }
}
